
export default [
    {
        path: '/price-rules',
        component: resolve => require(['../../views/personalCenter/priceRules.vue'], resolve),
        meta: { title: '二级结算价规则' }
    },
    {
        path: '/contract-rules',
        component: resolve => require(['../../views/personalCenter/contractRules.vue'], resolve),
        meta: { title: '合同价格规则' }
    },
    {
        path: '/business-rules',
        component: resolve => require(['../../views/personalCenter/businessRules.vue'], resolve),
        meta: { title: '业务规则' }
    },
    {
        path: '/myteam',
        component: resolve => require(['../../views/personalCenter/myTeam.vue'], resolve),
        meta: { title: '我的团队' }
    },
    {
        path: '/login-page-setting',
        component: resolve => require(['../../views/personalCenter/loginPageSetting.vue'], resolve),
        meta: { title: '登录页设置' }
    },
    {
        path: '/personal-setting',
        component: resolve => require(['../../views/personalCenter/personalSetting.vue'], resolve),
        meta: { title: '个人设置' }
    },
    {
        path: '/agreement',
        component: resolve => require(['../../views/personalCenter/agreement.vue'], resolve),
        meta: { title: '关于一人E店' }
    },
    {
        path: '/withdrawalAccount',
        component: resolve => require(['../../views/personalCenter/withdrawalAccount.vue'], resolve),
        meta: { title: '我的账户信息' }
    },
    
]



// WEBPACK FOOTER //
// ./src/TASMini/router/modules/personalCenter.js